import { cn } from "@/lib/utils";

// Reusable Galaxy League logo mark (uses the real brand image).
// The PNG ships on black; `mix-blend-mode: screen` removes the black so it
// blends cleanly into the dark navbar/footer surfaces.
export const PlanetLogo = ({ className }) => (
  <img
    src="/galaxy-logo.png"
    alt="Galaxy League"
    draggable="false"
    className={cn("h-8 w-8 select-none object-contain", className)}
    style={{
      mixBlendMode: "screen",
      filter: "drop-shadow(0 0 8px rgba(58,123,255,0.6))",
    }}
  />
);
